import { render, staticRenderFns } from "./Redirection.vue?vue&type=template&id=8dbd48f6"
import script from "./Redirection.vue?vue&type=script&lang=js"
export * from "./Redirection.vue?vue&type=script&lang=js"
import style0 from "./Redirection.vue?vue&type=style&index=0&id=8dbd48f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports